{
	"imprintTitle": "Impressum",
	"termsAndConditionsTitle": "Allgemeine Geschäftsbedingungen",
	"privacyPolicyTitle": "Datenschutzerklärung",
	"openSourceAttributionTitle": "Open-Source-Zuordnung"
}
